import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type BadgeStyle = 'emphasis' | 'success' | 'info' | 'alert' | 'default';

@Component({
  selector: 'i2g-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input() badgeStyle: BadgeStyle = 'default';
  @Input() text: string;

  constructor() {}
}
